import { useState, useEffect } from 'react';
import { Card, Btn, Pagination, usePagination } from '../../components/UI';
import NrpLookup from '../../components/NrpLookup';
import { useToast } from '../../components/Toast';
import { doselAPI } from '../../utils/api';

const th = { padding:'10px 14px',textAlign:'left',fontSize:12,fontWeight:700,color:'#64748B',borderBottom:'2px solid #E2E8F0' };
const td = { padding:'10px 14px',fontSize:13,borderBottom:'1px solid #F1F5F9' };

// ── DASHBOARD DOSEL ────────────────────────────────────────
const DashboardTab = () => {
  const [stats, setStats] = useState({ total_folder:0, total_dokumen:0, ukuran_total:'0 MB', terakhir_update:'-' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    doselAPI.getDashboard().then(r => setStats(r.data || stats)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const statCards = [
    { label:'Total Folder', value:stats.total_folder, color:'#2563EB', bg:'#EFF6FF' },
    { label:'Total Dokumen', value:stats.total_dokumen, color:'#059669', bg:'#ECFDF5' },
    { label:'Ukuran Total', value:stats.ukuran_total, color:'#D97706', bg:'#FFFBEB' },
    { label:'Terakhir Update', value:stats.terakhir_update, color:'#7C3AED', bg:'#F5F3FF' },
  ];

  return (
    <>
      <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))',gap:16,marginBottom:20 }}>
        {statCards.map(s => (
          <div key={s.label} style={{ background:s.bg,borderRadius:12,padding:20,border:`1px solid ${s.color}22` }}>
            <div style={{ fontSize:28,fontWeight:800,color:s.color }}>{loading ? '...' : s.value}</div>
            <div style={{ fontSize:13,color:'#6B7280',marginTop:4 }}>{s.label}</div>
          </div>
        ))}
      </div>
      <Card>
        <h3 style={{ margin:'0 0 12px',fontSize:15,fontWeight:700 }}>Tentang Dosel</h3>
        <p style={{ color:'#6B7280',fontSize:13,margin:0 }}>
          Dosel (Dokumen Elektronik) adalah modul untuk mengelola dokumen digital personel TNI AD.
          Gunakan menu <strong>Folder</strong> untuk mengelola struktur folder dan <strong>Rekap</strong> untuk laporan rekap dokumen.
        </p>
      </Card>
    </>
  );
};

// ── FOLDER ────────────────────────────────────────────────
const FolderTab = () => {
  const [data, setData] = useState([]);
  const [form, setForm] = useState({ nama_folder:'', deskripsi:'' });
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();
  const { page, setPage, pageSize, setPageSize, reset, paginate } = usePagination(10);
  useEffect(() => { reset(); }, [data]);

  const load = async () => {
    setLoading(true);
    try { const r = await doselAPI.getFolder(); setData(r.data || []); }
    catch {} finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nama_folder) return toast('Nama Folder wajib diisi', 'error');
    try {
      if (editId) { await doselAPI.updFolder(editId, form); toast('Folder berhasil diubah'); setEditId(null); }
      else { await doselAPI.addFolder(form); toast('Folder berhasil ditambah'); }
      setForm({ nama_folder:'', deskripsi:'' });
      load();
    } catch(e) { toast(e.message, 'error'); }
  };

  return (
    <>
      <Card>
        <h3 style={{ margin:'0 0 16px',fontSize:15,fontWeight:700 }}>{editId ? 'Edit' : 'Tambah'} Folder</h3>
        <form onSubmit={handleSubmit}>
          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16 }}>
            <div style={{ display:'flex',flexDirection:'column',gap:4 }}>
              <label style={{ fontSize:12,fontWeight:600,color:'#374151' }}>Nama Folder *</label>
              <input value={form.nama_folder} onChange={e => setForm(f=>({...f,nama_folder:e.target.value}))} placeholder="Nama folder dokumen"
                style={{ padding:'9px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:13,outline:'none',boxSizing:'border-box',fontFamily:'inherit' }}/>
            </div>
            <div style={{ display:'flex',flexDirection:'column',gap:4 }}>
              <label style={{ fontSize:12,fontWeight:600,color:'#374151' }}>Deskripsi</label>
              <input value={form.deskripsi} onChange={e => setForm(f=>({...f,deskripsi:e.target.value}))} placeholder="Keterangan folder"
                style={{ padding:'9px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:13,outline:'none',boxSizing:'border-box',fontFamily:'inherit' }}/>
            </div>
          </div>
          <div style={{ display:'flex',gap:8 }}>
            <Btn>{editId ? 'Update' : 'Tambah'}</Btn>
            {editId && <Btn variant="secondary" onClick={() => { setEditId(null); setForm({ nama_folder:'',deskripsi:'' }); }}>Batal</Btn>}
          </div>
        </form>
      </Card>
      <Card>
        <h3 style={{ margin:'0 0 12px',fontSize:15,fontWeight:700 }}>Daftar Folder ({data.length})</h3>
        {loading ? <p>Loading...</p> : (
          (() => { const { data: paged, total, totalPages, from, to } = paginate(data); return (<>
          <table style={{ width:'100%',borderCollapse:'collapse' }}>
            <thead><tr style={{ background:'#F8FAFC' }}>
              {['No','Nama Folder','Deskripsi','Jumlah Dokumen','Aksi'].map(h => <th key={h} style={th}>{h}</th>)}
            </tr></thead>
            <tbody>
              {paged.length === 0
                ? <tr><td colSpan={5} style={{ ...td,textAlign:'center',color:'#9CA3AF' }}>Belum ada folder</td></tr>
                : paged.map((r,i) => (
                  <tr key={r.id}>
                    <td style={td}>{from + i}</td>
                    <td style={td}>{r.nama_folder}</td>
                    <td style={td}>{r.deskripsi || '-'}</td>
                    <td style={td}>{r.jumlah_dokumen || 0}</td>
                    <td style={td}>
                      <div style={{ display:'flex',gap:6 }}>
                        <Btn variant="secondary" onClick={() => { setEditId(r.id); setForm({ nama_folder:r.nama_folder, deskripsi:r.deskripsi||'' }); }}>Edit</Btn>
                        <Btn variant="danger" onClick={async() => { try { await doselAPI.delFolder(r.id); load(); } catch(e){toast(e.message,'error');} }}>Hapus</Btn>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <Pagination page={page} totalPages={totalPages} total={total} from={from} to={to} pageSize={pageSize} onPageChange={setPage} onPageSizeChange={setPageSize} />
          </>); })()
        )}
      </Card>
    </>
  );
};

// ── REKAP ─────────────────────────────────────────────────
const RekapTab = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({ bulan:'', tahun:'' });
  const pgRekap = usePagination(10);
  useEffect(() => { pgRekap.reset(); }, [data]);

  const load = async () => {
    setLoading(true);
    const qs = Object.entries(filter).filter(([,v])=>v).map(([k,v])=>`${k}=${v}`).join('&');
    try { const r = await doselAPI.getRekap(qs ? `?${qs}` : ''); setData(r.data || []); }
    catch {} finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  return (
    <Card>
      <h3 style={{ margin:'0 0 16px',fontSize:15,fontWeight:700 }}>Rekap Dokumen Elektronik</h3>
      <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr auto',gap:16,marginBottom:16,alignItems:'end' }}>
        <div style={{ display:'flex',flexDirection:'column',gap:4 }}>
          <label style={{ fontSize:12,fontWeight:600,color:'#374151' }}>Bulan</label>
          <input type="number" value={filter.bulan} onChange={e => setFilter(f=>({...f,bulan:e.target.value}))} placeholder="1-12"
            style={{ padding:'9px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:13,outline:'none',boxSizing:'border-box',fontFamily:'inherit' }}/>
        </div>
        <div style={{ display:'flex',flexDirection:'column',gap:4 }}>
          <label style={{ fontSize:12,fontWeight:600,color:'#374151' }}>Tahun</label>
          <input type="number" value={filter.tahun} onChange={e => setFilter(f=>({...f,tahun:e.target.value}))} placeholder="2024"
            style={{ padding:'9px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:13,outline:'none',boxSizing:'border-box',fontFamily:'inherit' }}/>
        </div>
        <Btn onClick={load}>Filter</Btn>
      </div>
      {loading ? <p>Loading...</p> : (
        (() => { const { data: paged, total, totalPages, from, to } = pgRekap.paginate(data); return (<>
        <table style={{ width:'100%',borderCollapse:'collapse' }}>
          <thead><tr style={{ background:'#F8FAFC' }}>
            {['Folder','Total Dokumen','Bulan','Tahun','Terakhir Update'].map(h => <th key={h} style={th}>{h}</th>)}
          </tr></thead>
          <tbody>
            {paged.length === 0
              ? <tr><td colSpan={5} style={{ ...td,textAlign:'center',color:'#9CA3AF' }}>Tidak ada data rekap</td></tr>
              : paged.map((r,i) => (
                <tr key={i}>
                  <td style={td}>{r.nama_folder}</td>
                  <td style={td}>{r.total_dokumen}</td>
                  <td style={td}>{r.bulan}</td>
                  <td style={td}>{r.tahun}</td>
                  <td style={td}>{r.updated_at ? new Date(r.updated_at).toLocaleDateString('id-ID') : '-'}</td>
                </tr>
              ))}
          </tbody>
        </table>
        <Pagination page={pgRekap.page} totalPages={totalPages} total={total} from={from} to={to} pageSize={pgRekap.pageSize} onPageChange={pgRekap.setPage} onPageSizeChange={pgRekap.setPageSize} />
        </>); })()
      )}
    </Card>
  );
};

// ── DOKUMEN ──────────────────────────────────────────────
const DokumenTab = () => {
  const [data, setData] = useState([]);
  const [folders, setFolders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ nrp:'', folder_id:'', nama_dokumen:'', elemen:'' });
  const [file, setFile] = useState(null);
  const [selPers, setSelPers] = useState(null);
  const [filterNrp, setFilterNrp] = useState('');
  const [filterFolder, setFilterFolder] = useState('');
  const { toast } = useToast();
  const pg = usePagination(10);
  useEffect(() => { pg.reset(); }, [data]);

  const load = async () => {
    setLoading(true);
    const params = [];
    if (filterNrp) params.push(`nrp=${filterNrp}`);
    if (filterFolder) params.push(`folder_id=${filterFolder}`);
    const qs = params.length ? `?${params.join('&')}` : '';
    try { const r = await doselAPI.getDokumen(qs); setData(r.data || []); }
    catch {} finally { setLoading(false); }
  };

  useEffect(() => {
    doselAPI.getFolder().then(r => setFolders(r.data || [])).catch(() => {});
    load();
  }, []);

  useEffect(() => { load(); }, [filterNrp, filterFolder]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nrp || !form.nama_dokumen) return toast('NRP dan Nama Dokumen wajib diisi', 'error');
    const fd = new FormData();
    fd.append('nrp', form.nrp);
    fd.append('nama_dokumen', form.nama_dokumen);
    if (form.folder_id) fd.append('folder_id', form.folder_id);
    if (form.elemen) fd.append('elemen', form.elemen);
    if (file) fd.append('file', file);
    try {
      await doselAPI.uploadDokumen(fd);
      toast('Dokumen berhasil diupload');
      setForm({ nrp:'', folder_id:'', nama_dokumen:'', elemen:'' });
      setFile(null);
      setSelPers(null);
      load();
    } catch(e) { toast(e.message, 'error'); }
  };

  const formatSize = (bytes) => {
    if (!bytes) return '-';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1048576) return (bytes/1024).toFixed(1) + ' KB';
    return (bytes/1048576).toFixed(1) + ' MB';
  };

  return (
    <>
      <Card>
        <h3 style={{ margin:'0 0 16px',fontSize:15,fontWeight:700 }}>Upload Dokumen</h3>
        <form onSubmit={handleSubmit}>
          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16 }}>
            <div style={{ display:'flex',flexDirection:'column',gap:4 }}>
              <label style={{ fontSize:12,fontWeight:600,color:'#374151' }}>NRP Personel <span style={{color:'#EF4444'}}>*</span></label>
              <NrpLookup value={selPers} onSelect={(p) => { setSelPers(p); setForm(f=>({...f, nrp: p.nrp})); }} onClear={() => { setSelPers(null); setForm(f=>({...f, nrp:''})); }} />
            </div>
            <div style={{ display:'flex',flexDirection:'column',gap:4 }}>
              <label style={{ fontSize:12,fontWeight:600,color:'#374151' }}>Nama Dokumen <span style={{color:'#EF4444'}}>*</span></label>
              <input value={form.nama_dokumen} onChange={e => setForm(f=>({...f,nama_dokumen:e.target.value}))} placeholder="Nama dokumen"
                style={{ padding:'9px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:13,outline:'none',boxSizing:'border-box',fontFamily:'inherit' }}/>
            </div>
            <div style={{ display:'flex',flexDirection:'column',gap:4 }}>
              <label style={{ fontSize:12,fontWeight:600,color:'#374151' }}>Folder</label>
              <select value={form.folder_id} onChange={e => setForm(f=>({...f,folder_id:e.target.value}))}
                style={{ padding:'9px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:13,outline:'none',boxSizing:'border-box',fontFamily:'inherit',background:'white' }}>
                <option value="">— Tanpa Folder —</option>
                {folders.map(f => <option key={f.id} value={f.id}>{f.nama_folder}</option>)}
              </select>
            </div>
            <div style={{ display:'flex',flexDirection:'column',gap:4 }}>
              <label style={{ fontSize:12,fontWeight:600,color:'#374151' }}>Elemen (1-32)</label>
              <input type="number" min="1" max="32" value={form.elemen} onChange={e => setForm(f=>({...f,elemen:e.target.value}))} placeholder="Nomor elemen"
                style={{ padding:'9px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:13,outline:'none',boxSizing:'border-box',fontFamily:'inherit' }}/>
            </div>
          </div>
          <div style={{ marginBottom:16,display:'flex',flexDirection:'column',gap:4 }}>
            <label style={{ fontSize:12,fontWeight:600,color:'#374151' }}>File Dokumen</label>
            <input type="file" onChange={e => setFile(e.target.files[0])} accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.zip"
              style={{ padding:'8px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:13,boxSizing:'border-box',fontFamily:'inherit' }}/>
            <span style={{ fontSize:11,color:'#9CA3AF' }}>Maks 20MB. Format: PDF, JPG, PNG, DOC, XLS, ZIP</span>
          </div>
          <Btn>Upload Dokumen</Btn>
        </form>
      </Card>
      <Card>
        <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12 }}>
          <h3 style={{ margin:0,fontSize:15,fontWeight:700 }}>Daftar Dokumen ({data.length})</h3>
          <div style={{ display:'flex',gap:8 }}>
            <input placeholder="Filter NRP..." value={filterNrp} onChange={e => setFilterNrp(e.target.value)}
              style={{ width:150,padding:'8px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:12,outline:'none',boxSizing:'border-box',fontFamily:'inherit' }}/>
            <select value={filterFolder} onChange={e => setFilterFolder(e.target.value)}
              style={{ padding:'8px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:12,outline:'none',boxSizing:'border-box',fontFamily:'inherit',background:'white' }}>
              <option value="">Semua Folder</option>
              {folders.map(f => <option key={f.id} value={f.id}>{f.nama_folder}</option>)}
            </select>
          </div>
        </div>
        {loading ? <p>Loading...</p> : (
          (() => { const { data: paged, total, totalPages, from, to } = pg.paginate(data); return (<>
          <table style={{ width:'100%',borderCollapse:'collapse' }}>
            <thead><tr style={{ background:'#F8FAFC' }}>
              {['NRP','Nama','Dokumen','Folder','Elemen','File','Ukuran','Tanggal','Aksi'].map(h => <th key={h} style={th}>{h}</th>)}
            </tr></thead>
            <tbody>
              {paged.length === 0
                ? <tr><td colSpan={9} style={{ ...td,textAlign:'center',color:'#9CA3AF' }}>Belum ada dokumen</td></tr>
                : paged.map((r,i) => (
                  <tr key={r.id}>
                    <td style={{ ...td,fontFamily:'monospace',fontSize:12 }}>{r.nrp}</td>
                    <td style={td}>{r.nama || '-'}</td>
                    <td style={td}>{r.nama_dokumen}</td>
                    <td style={td}>{r.nama_folder || '-'}</td>
                    <td style={td}>{r.elemen || '-'}</td>
                    <td style={td}>{r.file_name ? <button onClick={() => doselAPI.downloadDokumen(r.id).catch(e => toast(e.message,'error'))} style={{ color:'#2563EB',fontSize:12,background:'none',border:'none',cursor:'pointer',textDecoration:'underline',padding:0,fontFamily:'inherit' }}>{r.file_name}</button> : '-'}</td>
                    <td style={{ ...td,fontSize:12 }}>{formatSize(r.file_size)}</td>
                    <td style={{ ...td,fontSize:12 }}>{new Date(r.uploaded_at).toLocaleDateString('id-ID')}</td>
                    <td style={td}>
                      <Btn size="sm" variant="danger" onClick={async () => {
                        if (!window.confirm(`Hapus dokumen "${r.nama_dokumen}"?`)) return;
                        try { await doselAPI.deleteDokumen(r.id); toast('Dokumen dihapus'); load(); } catch(e) { toast(e.message, 'error'); }
                      }}>Hapus</Btn>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <Pagination page={pg.page} totalPages={totalPages} total={total} from={from} to={to} pageSize={pg.pageSize} onPageChange={pg.setPage} onPageSizeChange={pg.setPageSize} />
          </>); })()
        )}
      </Card>
    </>
  );
};

// ── MAIN ─────────────────────────────────────────────────
export default function DoselPage() {
  const [tab, setTab] = useState('dashboard');
  const tabs = [
    { id:'dashboard', label:'Dashboard' },
    { id:'dokumen',   label:'Dokumen' },
    { id:'folder',    label:'Folder' },
    { id:'rekap',     label:'Rekap' },
  ];
  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <h1 style={{ fontSize:22,fontWeight:700,color:'#111827',margin:0 }}>Dosel</h1>
        <p style={{ color:'#6B7280',fontSize:13,margin:'4px 0 0' }}>Dokumen Elektronik Personel TNI AD</p>
      </div>
      <div style={{ display:'flex',gap:0,marginBottom:20,borderBottom:'2px solid #E5E7EB' }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{ padding:'10px 20px',border:'none',background:'none',cursor:'pointer',
              fontSize:13,fontWeight:tab===t.id?700:500,
              color:tab===t.id?'#2563EB':'#6B7280',
              borderBottom:tab===t.id?'2px solid #2563EB':'2px solid transparent',
              marginBottom:-2,fontFamily:'inherit',whiteSpace:'nowrap' }}>
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'dashboard' && <DashboardTab/>}
      {tab === 'dokumen'   && <DokumenTab/>}
      {tab === 'folder'    && <FolderTab/>}
      {tab === 'rekap'     && <RekapTab/>}
    </div>
  );
}
